import { tutorialImages } from "@/assets"

export type HowItWorksSlideKey = keyof typeof tutorialImages

export const getHowItWorksImg = (
  key: HowItWorksSlideKey,
  lang: string
): string => {
  const byLang = tutorialImages[key] as Record<string, string | undefined>
  return byLang[lang] ?? byLang.en ?? ""
}
